// src/components/DGKmodals/dgkForm/index.tsx
import {
  ModalCloseIco,
} from "@modules/CustomIcons";
import { Button, Checkbox, Form, Input, Modal, Pagination } from "antd";
import { connect, useSelector } from "react-redux";
import "./index.scss";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import imgExcell from "../../../assets/images/Group 205.svg";
import { downloadDgkExcel } from "./downloadXlsxDgk";
import SelectField from "components/SelectField";
import { ConvertBulk, GetCustomerCountries, GetCustomerCurrencies } from "../../services/Transfers/dgk";
interface ConvertData {
  toConvert: string;
  transferAmount: number;
  amountCurrency: [{ currency: string; amount: number }];
}
const formsPerPage = 1;

const DgkFormModal: React.FC<any> = (props: any) => {

  const dgkReduxData = useSelector((state: any) => state.dgk?.data);
  const getCountryLabel = (value: any) => {
    if (value === undefined || value === null || value === "") return "";
    const entry = countriesMap?.[String(value)];
    if (entry?.name) return entry.name;
    return String(value);
  };

  const getCurrencyLabel = (value: any) => {
    if (!value) return "";
    return String(value);
  };

  const normalizedPropDgkData = useMemo(() => {
    const type = String(props.dgkType || "").toUpperCase();
    const items = Array.isArray(props.dgkItems) ? props.dgkItems : [];
    const accountCurrency = props.accountCurrency || "";
    // console.log("propds",props);

    if (!type || !items.length) return null;

    if (type === "YGB") {
       console.log("item",items)
      return {
        type: "YGB",
        accountCurrency,
        pages: items.map((item: any, idx: number) => ({
         
          key: item.gbNumber || `ygb-${idx}`,
          gbNo: item.gbNumber,
          summary: {
            name: item.customerFullname,
            taxId: item.taxNumber,
            receiverCountry: item.beneficiaryCountry,
            invoiceCost: item.ygbInvoiceCost,
            invoiceCurrency: item.ccy,
            operationAmount: item.ygbOperationAmount,
            operationCurrency: item.ccy,
            egbSum: item.ygbRemainderAmount,
            egbCurrency: item.ygbRemainderCcy,
            deliveryCondition: item.pmtCondition,
            impDocDate: item.ygbImpDocDate,
            impDocCost: item.ygbDocCost,
            declarationTypeKey: item.ygbDeclareTypeKey,
            senderOrExporter: item.ygbSender,
            goodOfServiceInfo: item.goodServiceInfo,
            note: item.note,
            bankUserNumber: item.bankUserNumber,
          },
          form: {
            gbNo: item.gbNumber,
            name: item.customerFullname,
            receiverCountry: item.beneficiaryCountry,
            invoiceCost: `${item.ygbInvoiceCost ?? ""} ${item.ccy ?? ""}`.trim(),
            operationAmount: `${item.ygbOperationAmount ?? ""} ${item.ccy ?? ""}`.trim(),
            egbSum: `${item.ygbRemainderAmount ?? ""} ${item.ygbRemainderCcy ?? ""}`.trim(),
            contractNo: item.contractNumber,
            contractDate: item.ygbDocDate,
            receiverCountryId: getCountryLabel(item.countryCode),
            receiverName: item.beneficiaryName,
            transferredAmount: item.ygbAmount,
            currencyType: item.ccy,
            exchange: item.exchange || "",
          },
        })),
      };
    }

    if (type === "AKT") {
   
      return {
        type: "AKT",
        accountCurrency,
        pages: items.map((item: any, idx: number) => ({
          
          key: item.key || `akt-${idx}`,
          form: {
            actDocDate: item.actDocDate,
            noActDocNumber: typeof item.noActDocNumber === 'string'?(item.noActDocNumber ==='true'?true:false)  :!!item.noActDocNumber,
            actDocNumber: item.actDocNumber,
            actDocCost: item.actDocCost,
            actTransCost: item.actTransCost,
            currencyType: item.ccyCode,
            actExchange: item.actExchange || "",
            actSender: item.actSender,
            actServiceProvider: typeof item.actServiceProvider === 'string'?(item.actServiceProvider ==='true'?true:false)  :!!item.actServiceProvider ,
            actServiceProviderName: item.actServiceProviderName,
            goodServiceInfo: item.goodServiceInfo,
            countryId: item.country,
            note: item.note,
          },
        })),
      };
    }

    if (type === "AVANS") {
      const form: Record<string, any> = {};

      items.forEach((item: any, idx: number) => {
        form[`contNo-${idx}`] = item.advanceInvoiceNumber || "";
        form[`date-${idx}`] = item.advanceDate || "";
        form[`accountNo-${idx}`] = item.accountNumber || "";
        form[`avansReceiverCountryId-${idx}`] = item.country || "";
        form[`avansReceiver-${idx}`] = item.beneficiaryName || "";
        form[`avansTransferredAmount-${idx}`] = item.advanceAmount || "";
        form[`avansCurrencyType-${idx}`] = item.ccy || "";
        form[`avansExchange-${idx}`] = item.exchange || "";
      });

      return {
        type: "Avans",
        accountCurrency,
        pinCode: items[0]?.pin || "",
        summary: {
          pinCode: items[0]?.pin || "",
          taxId: items[0]?.taxNumber || "",
          name: items[0]?.customerFullName || "",
        },
        form,
        detailsCount: items.length,
      };
    }

    return null;
  }, [props.dgkType, props.dgkItems, props.accountCurrency]);

  const dgkData = normalizedPropDgkData || props.dgkData || dgkReduxData;
  
  const convertSingle = async (
    currency: string,
    amount: any,
    toCurrency: string
  ): Promise<string> => {
    const amt = normalizeDecimal(amount);
    const cur = String(currency ?? "").trim();
    const accCur = String(toCurrency ?? "").trim();

    if (!cur || !accCur || !Number.isFinite(amt) || amt <= 0) return "";

    if (cur === accCur) return "";

    const req: ConvertData = {
      toConvert: accCur,
      transferAmount: amt,
      amountCurrency: [{ currency: cur, amount: amt }],
    };

    const res = await ConvertBulk(req);

    if (!res || res?.status !== 200 || !res?.data) {
      return "";
    }

    const convertedAmount = res.data.amount;
    const resultCurrency = res.data.currency;

    if (
      convertedAmount === undefined ||
      convertedAmount === null ||
      !resultCurrency
    ) {
      return "";
    }

    return `${amt} ${cur} = ${convertedAmount} ${resultCurrency}`;
  };
  const { t } = useTranslation();
  // console.log("er",dgkData);

  const [ygbForm] = Form.useForm();
  const [aktForm] = Form.useForm();
  const [avansForm] = Form.useForm();
  const ygbWatchedValues = Form.useWatch([], ygbForm);
  const aktWatchedValues = Form.useWatch([], aktForm);
  const avansWatchedValues = Form.useWatch([], avansForm);
  const type = String(dgkData?.type || "").toUpperCase();

  const [page, setPage] = useState(1);

  const [countriesMap, setCountriesMap] = useState<Record<string, any>>({});
  const [currenciesMap, setCurrenciesMap] = useState<Record<string, any>>({});
  const [lookupsLoaded, setLookupsLoaded] = useState(false);

  const ygbPages = useMemo(
    () => (Array.isArray(dgkData?.pages) ? dgkData.pages : []),
    [dgkData]
  );
  const aktPages = useMemo(
    () => (Array.isArray(dgkData?.pages) ? dgkData.pages : []),
    [dgkData]
  );
  useEffect(() => {
    if (!props.visible) return;

    ygbForm.resetFields();
    aktForm.resetFields();
    avansForm.resetFields();
    setPage(1);
  }, [props.visible, dgkData, ygbForm, aktForm, avansForm]);
  const avansDetailsCount = useMemo(() => {
    if (dgkData?.detailsCount) return Number(dgkData.detailsCount);
    const values = dgkData?.form || {};
    const idx = new Set<number>();
    Object.keys(values).forEach((k: string) => {
      const m = k.match(/-(\d+)$/);
      if (m) idx.add(Number(m[1]));
    });
    return idx.size || 0;
  }, [dgkData]);

  useEffect(() => {
    if (!props.visible) return;
    setPage(1);
  }, [props.visible, type]);

  useEffect(() => {
    if (!props.visible) {
      setLookupsLoaded(false);
      return;
    }

    const loadLookups = async () => {
      try {
        const [countriesRes, currenciesRes] = await Promise.all([
          GetCustomerCountries(),
          GetCustomerCurrencies(),
        ]);
        setCountriesMap(countriesRes || {});
        setCurrenciesMap(currenciesRes || {});
        setLookupsLoaded(true);
      } catch (e) {
        console.error("DGK form lookups failed:", e);
        setLookupsLoaded(true);
      }
    };

    loadLookups();
  }, [props.visible]);



  const formatDateText = (value: any) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (value?.format) return value.format("DD.MM.YYYY");
    return String(value);
  };

  useEffect(() => {
    if (!props.visible) return;

    if (type === "YGB") {
      const current = ygbPages[page - 1];
      const summary = current?.summary || dgkData?.summary || {};
      const f = current?.form || current?.formValues || dgkData?.form || {};
console.log(f)
      ygbForm.setFieldsValue({
        gbNo: current?.gbNo || dgkData?.gbNo || f.gbNo,
        name: summary?.name || dgkData?.name || f.name,
        receiverCountry:
          summary?.receiverCountry || dgkData?.receiverCountry || f.receiverCountry,
        invoiceCost:
          summary?.invoiceCost || dgkData?.invoiceCost || f.invoiceCost,
        operationAmount:
          summary?.operationAmount ||
          dgkData?.operationAmount ||
          f.operationAmount,
        egbSum: summary?.egbSum || dgkData?.egbSum || f.egbSum,

        contractNo: f.contractNo,
        contractDate: formatDateText(f.contractDate),
        receiverCountryId: Object.keys(countriesMap).length > 0 ? getCountryLabel(f.receiverCountryId) : "",
        receiverName: f.receiverName,
        transferredAmount: f.transferredAmount,
        currencyType: getCurrencyLabel(f.currencyType),
        ...(f.exchange ? { exchange: f.exchange } : {}),
      });
    }

    if (type === "AKT") {
      const current = aktPages[page - 1];
      const f = current?.form || current?.formValues || dgkData?.form || {};
      
      aktForm.setFieldsValue({
        actDocDate: formatDateText(f.actDocDate),
        noActDocNumber: typeof f.noActDocNumber === 'string'?(f.noActDocNumber ==='true'?true:false)  :!!f.noActDocNumber,
        actDocNumber: f.actDocNumber,
        actDocCost: f.actDocCost,
        actTransCost: f.actTransCost,
        currencyType: getCurrencyLabel(f.currencyType),
        ...(f.actExchange ? { actExchange: f.actExchange } : {}),

        actSender: f.actSender,
        actServiceProvider:  typeof f.actServiceProvider === 'string'?(f.actServiceProvider ==='true'?true:false)  :!!f.actServiceProvider ,
        actServiceProviderName: f.actServiceProviderName,
        goodServiceInfo: f.goodServiceInfo,
        countryId: Object.keys(countriesMap).length > 0 ? getCountryLabel(f.countryId) : "",
        note: f.note,
      });
    }

    if (type === "AVANS") {
      const values = dgkData?.form || {};
      const startIndex = (page - 1) * formsPerPage;

      avansForm.setFieldsValue({
        ...values,
        [`avansReceiverCountryId-${startIndex}`]: Object.keys(countriesMap).length > 0 ? getCountryLabel(
          values[`avansReceiverCountryId-${startIndex}`]
        ) : "",
        [`avansCurrencyType-${startIndex}`]: getCurrencyLabel(
          values[`avansCurrencyType-${startIndex}`]
        ),
      });
    }
  }, [props.visible, type, page, dgkData, ygbPages, aktPages, ygbForm, aktForm, avansForm, countriesMap]);
  const normalizeDecimal = (v: any) => {
    const s = String(v ?? "").trim().replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : NaN;
  };

  const parseConvertedAmount = (exchangeValue?: string) => {
    const ex = String(exchangeValue || "").trim();
    const m = ex.match(/=\s*([0-9]+(?:\.[0-9]+)?)\s*([A-Z]{3})$/);
    if (!m) return null;

    const amount = Number(m[1]);
    const currency = m[2];

    if (!Number.isFinite(amount)) return null;

    return { amount, currency };
  };
  const resetModal = () => {
    props?.setVisible(false);
  };

  const handleExcelDownload = () => {
    downloadDgkExcel(dgkData || {});
  };

  const startIndex = (page - 1) * formsPerPage;

  const accountCurrency = useMemo(() => {
    const candidates = [
      dgkData?.accountCurrency,
      dgkData?.ibanCurrency,
      dgkData?.summary?.accountCurrency,
      dgkData?.toConvert,
      dgkData?.currency,
      dgkData?.pages?.[0]?.form?.currencyType,
      dgkData?.pages?.[0]?.formValues?.currencyType,
      dgkData?.form?.[`avansCurrencyType-0`],
    ];

    const found = candidates.find(
      (v) => typeof v === "string" && /^[A-Z]{3}$/.test(v.trim())
    );

    return found ? found.trim() : "";
  }, [dgkData]);

  const computeExchangeTotalFromPages = (
    pages: Array<{ form?: any; formValues?: any }>,
    type: "YGB" | "AKT"
  ) => {
    let total = 0;

    for (const p of pages) {
      const values = p?.formValues || p?.form || {};

      const rawAmount =
        type === "YGB"
          ? normalizeDecimal(values?.transferredAmount)
          : normalizeDecimal(values?.actTransCost);

      const selectedCurrency = String(values?.currencyType || "").trim();

      if (!selectedCurrency || !Number.isFinite(rawAmount)) continue;

      // same currency -> use entered amount directly
      if (selectedCurrency === accountCurrency) {
        total += rawAmount;
        continue;
      }

      // different currency -> use converted exchange field
      const parsed = parseConvertedAmount(values?.exchange || values?.actExchange);
      if (!parsed) continue;

      if (
        (!accountCurrency || parsed.currency === accountCurrency) &&
        Number.isFinite(parsed.amount)
      ) {
        total += parsed.amount;
      }
    }

    return total;
  };

  const ygbExchangeTotal = useMemo(() => {
    const pages = ygbPages.map((p: any, idx: any) =>
      idx === page - 1
        ? {
          ...p,
          form: {
            ...(p.form || p.formValues || {}),
            ...(ygbWatchedValues || {}),
          },
        }
        : p
    );

    return computeExchangeTotalFromPages(pages, "YGB");
  }, [ygbPages, accountCurrency, page, ygbWatchedValues]);

  const aktExchangeTotal = useMemo(() => {
    const pages = aktPages.map((p: any, idx: any) =>
      idx === page - 1
        ? {
          ...p,
          form: {
            ...(p.form || p.formValues || {}),
            ...(aktWatchedValues || {}),
          },
        }
        : p
    );

    return computeExchangeTotalFromPages(pages, "AKT");
  }, [aktPages, accountCurrency, page, aktWatchedValues]);

  const avansExchangeTotal = useMemo(() => {
    const values = {
      ...(dgkData?.form || {}),
      ...(avansWatchedValues || {}),
    };

    let total = 0;

    for (let i = 0; i < avansDetailsCount; i++) {
      const rawAmount = normalizeDecimal(values[`avansTransferredAmount-${i}`]);
      const selectedCurrency = String(values[`avansCurrencyType-${i}`] || "").trim();

      if (!selectedCurrency || !Number.isFinite(rawAmount)) continue;

      if (selectedCurrency === accountCurrency) {
        total += rawAmount;
        continue;
      }

      const parsed = parseConvertedAmount(values[`avansExchange-${i}`]);
      if (!parsed) continue;

      if (
        (!accountCurrency || parsed.currency === accountCurrency) &&
        Number.isFinite(parsed.amount)
      ) {
        total += parsed.amount;
      }
    }

    return total;
  }, [dgkData, avansWatchedValues, avansDetailsCount, accountCurrency]);
  useEffect(() => {
    const fillYgbExchange = async () => {
      if (!props.visible || type !== "YGB") return;

      const current = ygbPages[page - 1];
      const f = current?.form || current?.formValues || dgkData?.form || {};

      const existingExchange = f.exchange;
      const currencyType = f.currencyType;
      const transferredAmount = f.transferredAmount;

      if (existingExchange) {
        ygbForm.setFieldsValue({ exchange: existingExchange });
        return;
      }

      if (!currencyType || !transferredAmount || !accountCurrency) {
        ygbForm.setFieldsValue({ exchange: "" });
        return;
      }

      const calculatedExchange = await convertSingle(
        currencyType,
        transferredAmount,
        accountCurrency
      );

      ygbForm.setFieldsValue({
        exchange: calculatedExchange,
      });
    };

    fillYgbExchange();
  }, [props.visible, type, page, ygbPages, dgkData, accountCurrency, ygbForm]);
  useEffect(() => {
    const fillAvansExchange = async () => {
      if (!props.visible || type !== "AVANS") return;

      const values = dgkData?.form || {};
      const existingExchange = values[`avansExchange-${startIndex}`];
      const currencyType = values[`avansCurrencyType-${startIndex}`];
      const amount = values[`avansTransferredAmount-${startIndex}`];

      if (existingExchange) {
        avansForm.setFieldsValue({
          [`avansExchange-${startIndex}`]: existingExchange,
        });
        return;
      }

      if (!currencyType || !amount || !accountCurrency) {
        avansForm.setFieldsValue({
          [`avansExchange-${startIndex}`]: "",
        });
        return;
      }

      const calculatedExchange = await convertSingle(
        currencyType,
        amount,
        accountCurrency
      );

      avansForm.setFieldsValue({
        [`avansExchange-${startIndex}`]: calculatedExchange,
      });
    };

    fillAvansExchange();
  }, [props.visible, type, startIndex, dgkData, accountCurrency, avansForm]);
  useEffect(() => {
    const fillAktExchange = async () => {
      if (!props.visible || type !== "AKT") return;

      const current = aktPages[page - 1];
      const f = current?.form || current?.formValues || dgkData?.form || {};

      const existingExchange = f.actExchange;
      const currencyType = f.currencyType;
      const amount = f.actTransCost;

      if (existingExchange) {
        aktForm.setFieldsValue({ actExchange: existingExchange });
        return;
      }

      if (!currencyType || !amount || !accountCurrency) {
        aktForm.setFieldsValue({ actExchange: "" });
        return;
      }

      const calculatedExchange = await convertSingle(
        currencyType,
        amount,
        accountCurrency
      );

      aktForm.setFieldsValue({
        actExchange: calculatedExchange,
      });
    };

    fillAktExchange();
  }, [props.visible, type, page, aktPages, dgkData, accountCurrency, aktForm]);
  return (
    <Modal
      destroyOnClose
      title={
        type === "YGB"
          ? t("dgk.ygb_registration")
          : type === "AKT"
            ? t("dgk.akt")
            : t("dgk.advance")
      }
      closeIcon={<ModalCloseIco />}
      centered
      open={props.visible && lookupsLoaded}
      onCancel={resetModal}
      width={type === "AVANS" ? 831 : 590}
      className={`manage_faster_menus swift_modal template_list_popup_modal template_modal dgkModal formModal ${props?.className || ""
        } `}
      keyboard={false}
      focusTriggerAfterClose={false}
      footer={false}
    >
      {type === "YGB" && (
        <div className="val" style={{
          gap: "24px"
        }}>
          <div
            className="paymentContainer paymentNoPadding"
            style={{
              backgroundColor: "transparent",
              padding: "0"
            }}
          >
            <p
              className="topTxt"
              style={{
                marginBottom: "1rem",
              }}
            >
              {t("dgk.customs_general_info")}
            </p>

            <div className="form">
              <Form form={ygbForm}>
                <div className="flex">
                  <Form.Item label={t("dgk.gb_number")} name="gbNo">
                    <Input  disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>

                  <Form.Item label={t("dgk.legal_entity_name")} name="name">
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>
                </div>

                <div className="flex">
                  <Form.Item
                    label={t("dgk.recipient_country")}
                    name="receiverCountry"
                  >
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>

                  <Form.Item label={t("dgk.invoice_value")} name="invoiceCost">
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>
                </div>

                <div className="flex flex-last">
                  <Form.Item
                    label={t("dgk.transaction_amount")}
                    name="operationAmount"
                  >
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>

                  <Form.Item
                    label={t("dgk.gb_remaining_amount")}
                    name="egbSum"
                  >
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>

          <div
            className="line"
            style={{
              margin: "0px",
            }}
          />
          <div
            className="paymentContainer paymentNoPadding"
            style={{
              backgroundColor: "transparent",
              padding: "0"
            }}
          >
            <p
              className="topTxt"
              style={{
                marginBottom: "1rem",
              }}
            >
              {t("dgk.gb_contract_invoice_info")}
            </p>

            <div className="form">
              <Form form={ygbForm}>
                <div className="flex">
                  <Form.Item label={t("dgk.contract_number")} name="contractNo">
                    <Input   readOnly className="ygbreadonly validationInput" />
                  </Form.Item>

                  <Form.Item label={t("dgk.contract_date")} name="contractDate">
                    <Input disabled readOnly maxLength={70} className="validationInput" />
                  </Form.Item>
                </div>

                <div className="flex">
                  <Form.Item label={t("dgk.recipient_country")} name="receiverCountryId">
                    <Input  readOnly className="ygbreadonly validationInput" />
                  </Form.Item>

                  <Form.Item label={t("dgk.recipient")} name="receiverName">
                    <Input 
                      readOnly
                      style={{ backgroundColor: "white" }}
                      maxLength={70}
                      className="ygbreadonly validationInput"
                    />
                  </Form.Item>
                </div>

                <div className="flex flex-end">
                  <Form.Item
                    label={t("dgk.gb_transferred_amount")}
                    name="transferredAmount"
                    className="sideInput"
                  >
                    <Input 
                      readOnly
                      style={{ backgroundColor: "white" }}
                      maxLength={70}
                      className="ygbreadonly validationInput"
                    />
                  </Form.Item>

                  <Form.Item
                    label={t("dgk.currency")}
                    name="currencyType"
                    className="gbNoInput"
                  >
                    <Input  readOnly className="ygbreadonly validationInput" />
                  </Form.Item>

                  <Form.Item
                    label={t("dgk.exchange_by_account_currency")}
                    name="exchange"
                    className="sideInputRight"
                  >
                    <Input disabled readOnly maxLength={70} className="validationInput" style={{
                      width: "100%"
                    }} />
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>

          <Pagination
            current={page}
            pageSize={1}
            total={ygbPages.length}
            onChange={(p) => setPage(p)}
            className="paginationDesign"
          />

          <div className="bottom">
            <div className="price">
              <span>{t("dgk.total_exchange_amount_ygb")}:</span>
              <div>
                {(ygbExchangeTotal || 0).toFixed(2)} {accountCurrency || "—"}
              </div>
            </div>

            <div className="actionButtons">
              <Button className="excellDownload" onClick={handleExcelDownload}>
                <div className="excellRound">
                  <img src={imgExcell} alt="" />
                </div>
              </Button>
            </div>
          </div>
        </div>
      )}

      {type === "AKT" && (
        <div className="val aktForm">
          <div className="paymentContainer">
            <div className="aktHead">
              <p className="topTxt">{t("dgk.general_information")}</p>
            </div>
            <div className="linee" />

            <div className="form">
              <Form form={aktForm}>
                <div className="flex">
                  <Form.Item label={t("dgk.act_date")} name="actDocDate">
                    <Input  readOnly className="validationInput dgkFormActDate" />
                  </Form.Item>

                  <div className="innerFlex">
                    <Form.Item
                      label={t("dgk.act_number")}
                      name="noActDocNumber"
                      className="leftInput"
                      valuePropName="checked"
                    >
                      <Checkbox  disabled checked={aktForm.getFieldValue("noActDocNumber")==='true' || aktForm.getFieldValue("noActDocNumber")}/>
                      {t("dgk.none")}
                    </Form.Item>

                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => (
                        <Form.Item label=" " name="actDocNumber" className="rightInput">
                          <Input
                            disabled={!!getFieldValue("noActDocNumber")}
                            readOnly
                            className="validationInput"
                          />
                        </Form.Item>
                      )}
                    </Form.Item>
                  </div>
                </div>

                <div className="flex">
                  <Form.Item
                    label={t("dgk.total_document_amount")}
                    name="actDocCost"
                  >
                    <Input  readOnly className="validationInput" />
                  </Form.Item>

                  <Form.Item
                    label={t("dgk.transferred_amount")}
                    name="actTransCost"
                  >
                    <Input  readOnly className="validationInput" />
                  </Form.Item>

                  <Form.Item
                    label={t("dgk.currency")}
                    name="currencyType"
                    className="gbNoInput"
                  >
                    <Input  readOnly className="validationInput" />
                  </Form.Item>
                </div>

                <div className="flex flex-last-akt">
                  <Form.Item
                    label={t("dgk.exchange_by_account_currency")}
                    name="actExchange"
                  >
                    <Input disabled readOnly className="validationInput" />
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>

          <div className="paymentContainer">
            <p className="topTxt">{t("dgk.sender_exporter")}</p>

            <Form form={aktForm}>
              <div className="flex">
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => (
                    <Form.Item label={t("dgk.act_recipient")} name="actSender">
                      <Input
                        disabled={!getFieldValue("actSender")}
                        readOnly
                        className="validationInput"
                      />
                    </Form.Item>
                  )}
                </Form.Item>

                <div className="innerFlex2">
                  <Form.Item
                    label={t("dgk.service_provider")}
                    name="actServiceProvider"
                    className="leftInput"
                    valuePropName="checked"
                  >
                    <Checkbox disabled checked={aktForm.getFieldValue("actServiceProvider")==='true' || aktForm.getFieldValue("actServiceProvider")} />
                    {t("dgk.available")}
                  </Form.Item>

                  <Form.Item shouldUpdate noStyle>
                    {({ getFieldValue }) => (
                      <Form.Item
                        label=" "
                        name="actServiceProviderName"
                        className="rightInput"
                      >
                        <Input
                          disabled={!getFieldValue("actServiceProvider")}
                          readOnly
                          className="validationInput"
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </div>
              </div>

              <div className="flex firstLong">
                <Form.Item
                  label={t("dgk.goods_services_info")}
                  name="goodServiceInfo"
                  className="first"
                >
                  <Input  readOnly className="validationInput" />
                </Form.Item>

                <Form.Item label={t("dgk.country")} name="countryId" className="gbNoInput">
                  <Input  readOnly className="validationInput" />
                </Form.Item>
              </div>

              <div className="flex flex-end">
                <Form.Item label={t("dgk.note")} name="note" className="fullText">
                  <TextArea
                  
                    readOnly
                    placeholder={t("dgk.common.not_entered")}
                    className="validationInput"
                  />
                </Form.Item>
              </div>
            </Form>
          </div>

          {aktPages.length > 1 && (
            <Pagination
              current={page}
              pageSize={1}
              total={aktPages.length}
              onChange={(p) => setPage(p)}
              className="paginationDesign"
            />
          )}

          <div className="bottom">
            <div className="price">
              <span>{t("dgk.total_exchange_amount_akt")}:</span>
              <div>
                {(aktExchangeTotal || 0).toFixed(2)} {accountCurrency || "—"}
              </div>
            </div>

            <div className="actionButtons">
              <Button className="excellDownload" onClick={handleExcelDownload}>
                <div className="excellRound">
                  <img src={imgExcell} alt="" />
                </div>
              </Button>
            </div>
          </div>
        </div>
      )}

      {type === "AVANS" && (
        <div className="val2 avansModalView">
          <div className="contentBox">
            <div className="topInfoRow">
              <div className="infoItem">
                <p>{t("dgk.advance_pin")}</p>
                <span>{dgkData?.pinCode || dgkData?.summary?.pinCode || ""}</span>
              </div>

              <div className="infoItem">
                <p>{t("dgk.tin")}</p>
                <span>{dgkData?.summary?.taxId || dgkData?.taxId || ""}</span>
              </div>

              <div className="infoItem large">
                <p>{t("dgk.legal_individual_name")}</p>
                <span>{dgkData?.summary?.name || dgkData?.name || ""}</span>
              </div>
            </div>

            <div
              className="line"
              style={{
                margin: 0,
              }}
            />

            <div className="formBody">
              <div className="formTitleRow">
                <h3>{t("dgk.new_advance_registration")}</h3>
              </div>

              <Form form={avansForm} className="formAvans">
                <div className="avansInside">
                  <div className="flex threeCols">
                    <Form.Item
                      label={t("dgk.contract_number")}
                      name={`contNo-${startIndex}`}
                      className="contractField"
                    >
                      <Input disabled readOnly className="validationInput" />
                    </Form.Item>

                    <Form.Item
                      label={t("dgk.contract_date")}
                      name={`date-${startIndex}`}
                      className="dateField"
                    >
                      <Input disabled readOnly className="validationInput" />
                    </Form.Item>

                    <Form.Item
                      label={t("dgk.account_number")}
                      name={`accountNo-${startIndex}`}
                      className="accountField"
                    >
                      <Input disabled readOnly className="validationInput" />
                    </Form.Item>
                  </div>

                  <div className="flex secondRow">
                    <Form.Item
                      label={t("dgk.country")}
                      name={`avansReceiverCountryId-${startIndex}`}
                      className="countryField"
                      
                    >
                      <Input  readOnly className="validationInput" />
                    </Form.Item>

                    <Form.Item
                      label={t("dgk.counterparty")}
                      name={`avansReceiver-${startIndex}`}
                      className="receiverField"
                    >
                      <Input className="validationInput" />
                    </Form.Item>

                    <Form.Item
                      label={t("dgk.amount")}
                      name={`avansTransferredAmount-${startIndex}`}
                      className="amountField"
                    >
                      <Input  readOnly className="validationInput" />
                    </Form.Item>

                    <Form.Item
                      label={t("dgk.currency")}
                      name={`avansCurrencyType-${startIndex}`}
                      className="currencyField"
                    >
                      <Input  readOnly className="validationInput" />
                    </Form.Item>
                  </div>

                  <div className="flex exchangeRow">
                    <div className="exchangeSpacer" />

                    <Form.Item
                      label={`${t("dgk.exchange_by_account_currency")}:`}
                      name={`avansExchange-${startIndex}`}
                      
                      className="exchangeField"
                    >
                      <Input disabled  readOnly className="validationInput" />
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>

            <div className="pagFull">
              <Pagination
                current={page}
                pageSize={formsPerPage}
                total={avansDetailsCount}
                onChange={(p) => setPage(p)}
                className="paginationDesign avansPagination"
              />
            </div>

            <div className="bottom avansBottom">
              <div className="price">
                <span>{t("dgk.total_exchange_amount_avans")}:</span>
                <div>
                  {(avansExchangeTotal || 0).toFixed(2)} {accountCurrency || "—"}
                </div>
              </div>

              <div className="actionButtons">
                <Button
                  className="excellDownload avansExcelBtn"
                  onClick={handleExcelDownload}
                >
                  <div className="excellRound">
                    <img src={imgExcell} alt="" />
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default connect(null, null)(DgkFormModal);